import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';
import { findWithUUID } from '@/utils/uuidHelper';
import { updateActiveLookup } from '../../dictionaries/actions';

const listItems = (lookups, name, saveErrors, validationWarnings) => {
  const warnings = validationWarnings.map((warning) => warning.context.lookupName);
  const errors = saveErrors.map((error) => error.context.lookupName);

  return (
    lookups.map((lookup) => {
      let highlightClass = '';
      if (errors.includes(lookup)) {
        highlightClass = 'error';
      } else if (warnings.includes(lookup)) {
        highlightClass = 'warning';
      }

      return {
        active: lookup === name,
        className: highlightClass,
        key: `dictionary_lookup_dropdown_item_${lookup}`,
        text: lookup,
        value: lookup,
      };
    }));
};

const DictionaryLookupDropdown = ({
  lookups,
  name,
  changeLookup,
  saveErrors,
  validationWarnings,
}) => {
  const keys = Object.keys(lookups).sort();
  if (keys.length === 1) {
    return (<p className="aridhia-dictionary-lookup-dropdown-single" title={name}>{name}</p>);
  }

  return (
    <Dropdown
      className="aridhia-dictionary-lookup-dropdown"
      inline
      scrolling
      options={listItems(keys, name, saveErrors, validationWarnings)}
      value={name}
      onChange={(e, { value }) => changeLookup(value)}
    />
  );
};

const mapStateToProps = ({
  datasets: {
    lookups,
  },
}) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);

  return (
    {
      lookups: dictionary ? dictionary.lookups || {} : {},
      name: lookups.activeLookupName,
      saveErrors: lookups.saveErrors,
      validationWarnings: lookups.validationWarnings,
    }
  );
};

const mapDispatchToProps = {
  changeLookup: updateActiveLookup,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryLookupDropdown);
